
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.2.0
 * Query Engine version: 23fdc5965b1e05fc54e5f26ed3de66776b93de64
 */
Prisma.prismaVersion = {
  client: "5.2.0",
  engine: "23fdc5965b1e05fc54e5f26ed3de66776b93de64"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  seoTitle: 'seoTitle',
  title: 'title',
  slug: 'slug',
  description: 'description',
  priceCents: 'priceCents',
  contentfulId: 'contentfulId',
  sizeMatrixId: 'sizeMatrixId',
  storeId: 'storeId',
  productRangeId: 'productRangeId'
};

exports.Prisma.ProductOptionScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  required: 'required',
  isVariant: 'isVariant',
  storeId: 'storeId'
};

exports.Prisma.ProductOptionValueScalarFieldEnum = {
  id: 'id',
  name: 'name',
  productOptionId: 'productOptionId',
  storeId: 'storeId'
};

exports.Prisma.ProductOptionOnProductsScalarFieldEnum = {
  productId: 'productId',
  productOptionId: 'productOptionId'
};

exports.Prisma.ProductOptionValuesOnSkusScalarFieldEnum = {
  skuId: 'skuId',
  productOptionValueId: 'productOptionValueId'
};

exports.Prisma.ColorScalarFieldEnum = {
  id: 'id',
  type: 'type',
  createdAt: 'createdAt',
  title: 'title',
  hex: 'hex',
  storeId: 'storeId'
};

exports.Prisma.SizeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  title: 'title',
  symbol: 'symbol',
  sizeMatrixId: 'sizeMatrixId',
  order: 'order',
  storeId: 'storeId'
};

exports.Prisma.SizeMatrixScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  title: 'title',
  storeId: 'storeId'
};

exports.Prisma.CurrencyScalarFieldEnum = {
  id: 'id',
  iso: 'iso',
  countryIso: 'countryIso'
};

exports.Prisma.ProductVariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  title: 'title',
  code: 'code',
  slug: 'slug',
  productId: 'productId',
  colorId: 'colorId',
  completeTheLookProductVariantGridId: 'completeTheLookProductVariantGridId',
  storeId: 'storeId',
  isCanonical: 'isCanonical',
  contentfulId: 'contentfulId',
  productOptionValueId: 'productOptionValueId'
};

exports.Prisma.ProductRangeScalarFieldEnum = {
  id: 'id',
  name: 'name',
  description: 'description',
  coverUrl: 'coverUrl',
  slug: 'slug',
  createdAt: 'createdAt',
  storeId: 'storeId',
  lookbookContentfulId: 'lookbookContentfulId'
};

exports.Prisma.SkuScalarFieldEnum = {
  id: 'id',
  title: 'title',
  coverUrl: 'coverUrl',
  createdAt: 'createdAt',
  stock: 'stock',
  productId: 'productId',
  colorId: 'colorId',
  sizeId: 'sizeId',
  productVariantId: 'productVariantId',
  storeId: 'storeId'
};

exports.Prisma.CustomerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  name: 'name',
  newsletterSubscribeDate: 'newsletterSubscribeDate',
  newsletterUnsubscribeDate: 'newsletterUnsubscribeDate',
  storeId: 'storeId'
};

exports.Prisma.LogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  storeId: 'storeId',
  status: 'status',
  service: 'service',
  externalId: 'externalId',
  requestBody: 'requestBody',
  responseBody: 'responseBody'
};

exports.Prisma.AddressScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  street1: 'street1',
  street2: 'street2',
  city: 'city',
  zip: 'zip',
  phone: 'phone',
  countryIsoCode: 'countryIsoCode',
  storeId: 'storeId'
};

exports.Prisma.CheckoutScalarFieldEnum = {
  id: 'id',
  status: 'status',
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  customerId: 'customerId',
  addressId: 'addressId',
  paymentIntentId: 'paymentIntentId',
  paymentIntentClientSecret: 'paymentIntentClientSecret',
  discountCodeAppliedAt: 'discountCodeAppliedAt',
  discountCodeId: 'discountCodeId',
  isGift: 'isGift',
  completedAt: 'completedAt',
  storeId: 'storeId',
  ip: 'ip',
  subtotal: 'subtotal',
  subtotalGross: 'subtotalGross',
  discount: 'discount',
  discountGross: 'discountGross',
  delivery: 'delivery',
  salesTax: 'salesTax',
  salesTaxRate: 'salesTaxRate',
  total: 'total',
  totalGross: 'totalGross',
  signupToNewsletter: 'signupToNewsletter',
  shippingServiceId: 'shippingServiceId',
  currencyIso: 'currencyIso',
  currencyExchangeRate: 'currencyExchangeRate',
  trackingNumber: 'trackingNumber',
  posthogSessionId: 'posthogSessionId',
  abandonedCartEmailId: 'abandonedCartEmailId',
  source: 'source',
  storeMarketId: 'storeMarketId',
  referrer: 'referrer'
};

exports.Prisma.CheckoutLineItemScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  quantity: 'quantity',
  checkoutId: 'checkoutId',
  skuId: 'skuId',
  storeId: 'storeId'
};

exports.Prisma.DiscountScalarFieldEnum = {
  id: 'id',
  code: 'code',
  createdAt: 'createdAt',
  amount: 'amount',
  type: 'type',
  storeId: 'storeId',
  startDate: 'startDate',
  endDate: 'endDate',
  archivedDate: 'archivedDate',
  isWelcomeDiscount: 'isWelcomeDiscount'
};

exports.Prisma.AssetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  url: 'url',
  storeId: 'storeId'
};

exports.Prisma.ShipmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  storeId: 'storeId',
  trackingCode: 'trackingCode',
  shippingServiceId: 'shippingServiceId',
  checkoutId: 'checkoutId'
};

exports.Prisma.ShipmentLineItemsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  shipmentId: 'shipmentId',
  checkoutLineItemId: 'checkoutLineItemId',
  quantity: 'quantity'
};

exports.Prisma.AssetEntityScalarFieldEnum = {
  id: 'id',
  assetId: 'assetId',
  type: 'type',
  order: 'order',
  productVariantId: 'productVariantId',
  productImagesProductId: 'productImagesProductId',
  productLifestyleImagesProductId: 'productLifestyleImagesProductId',
  productRangeId: 'productRangeId',
  categoryId: 'categoryId',
  productId: 'productId'
};

exports.Prisma.ProductVariantGridScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createdAt: 'createdAt'
};

exports.Prisma.ProductVariantGridOnProductVariantsScalarFieldEnum = {
  productVariantId: 'productVariantId',
  productVariantGridId: 'productVariantGridId',
  assignedAt: 'assignedAt'
};

exports.Prisma.CategoryScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  description: 'description',
  slug: 'slug',
  parentId: 'parentId',
  storeId: 'storeId'
};

exports.Prisma.CategoriesOnProductsScalarFieldEnum = {
  productId: 'productId',
  categoryId: 'categoryId',
  assignedAt: 'assignedAt',
  assignedBy: 'assignedBy'
};

exports.Prisma.ShippingZoneScalarFieldEnum = {
  id: 'id',
  name: 'name',
  countryIsoCodes: 'countryIsoCodes',
  storeId: 'storeId'
};

exports.Prisma.ShippingServiceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  carrierName: 'carrierName',
  priceCents: 'priceCents',
  freeShippingThresholdCents: 'freeShippingThresholdCents',
  storeId: 'storeId'
};

exports.Prisma.ShippingZonesOnServicesScalarFieldEnum = {
  zoneId: 'zoneId',
  serviceId: 'serviceId'
};

exports.Prisma.AdminUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  email: 'email',
  password: 'password'
};

exports.Prisma.StoreCurrenciesScalarFieldEnum = {
  id: 'id',
  currencyId: 'currencyId',
  storeId: 'storeId',
  currencyRate: 'currencyRate',
  isDefault: 'isDefault'
};

exports.Prisma.StoreScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name'
};

exports.Prisma.ProductMaterialsScalarFieldEnum = {
  productId: 'productId',
  materialOptionValueId: 'materialOptionValueId',
  assignedAt: 'assignedAt',
  assignedBy: 'assignedBy'
};

exports.Prisma.MaterialScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  storeId: 'storeId',
  name: 'name',
  createdAt: 'createdAt'
};

exports.Prisma.MaterialOptionScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  storeId: 'storeId',
  name: 'name',
  createdAt: 'createdAt',
  materialId: 'materialId',
  default: 'default'
};

exports.Prisma.MaterialOptionValueScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  storeId: 'storeId',
  name: 'name',
  createdAt: 'createdAt',
  materialOptionId: 'materialOptionId'
};

exports.Prisma.MaterialPriceScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  storeId: 'storeId',
  quantityMin: 'quantityMin',
  quantityMax: 'quantityMax',
  priceCents: 'priceCents',
  createdAt: 'createdAt'
};

exports.Prisma.SupplierScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  storeId: 'storeId',
  name: 'name',
  createdAt: 'createdAt'
};

exports.Prisma.PurchaseOrderScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  storeId: 'storeId',
  name: 'name',
  createdAt: 'createdAt'
};

exports.Prisma.WebhookScalarFieldEnum = {
  id: 'id',
  storeId: 'storeId',
  url: 'url',
  createdAt: 'createdAt'
};

exports.Prisma.WebhookLogScalarFieldEnum = {
  id: 'id',
  response: 'response',
  createdAt: 'createdAt',
  webhookId: 'webhookId'
};

exports.Prisma.BundleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  name: 'name',
  description: 'description',
  slug: 'slug',
  imagesContentfulId: 'imagesContentfulId',
  metaContentfulId: 'metaContentfulId',
  discount: 'discount',
  storeId: 'storeId'
};

exports.Prisma.BundlesOnProductVariantsScalarFieldEnum = {
  productVariantId: 'productVariantId',
  bundleId: 'bundleId'
};

exports.Prisma.InternalApiRequestLogScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  storeId: 'storeId',
  function: 'function',
  timeMs: 'timeMs'
};

exports.Prisma.ProductPriceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  priceCentsNet: 'priceCentsNet',
  storeId: 'storeId',
  productId: 'productId',
  marketId: 'marketId'
};

exports.Prisma.StoreMarketScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  name: 'name',
  createdAt: 'createdAt',
  countryIsoCodes: 'countryIsoCodes',
  storeId: 'storeId'
};

exports.Prisma.NotificationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  email: 'email',
  storeId: 'storeId',
  skuId: 'skuId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.VariantTypes = exports.$Enums.VariantTypes = {
  COLOR: 'COLOR',
  SCENT: 'SCENT'
};

exports.SizeSymbols = exports.$Enums.SizeSymbols = {
  S: 'S',
  M: 'M',
  L: 'L'
};

exports.LogStatus = exports.$Enums.LogStatus = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

exports.CheckoutStatus = exports.$Enums.CheckoutStatus = {
  Draft: 'Draft',
  Complete: 'Complete',
  Cancelled: 'Cancelled'
};

exports.DiscountTypes = exports.$Enums.DiscountTypes = {
  FIXED: 'FIXED',
  PERCENT: 'PERCENT'
};

exports.AssetEntityType = exports.$Enums.AssetEntityType = {
  Product: 'Product',
  Category: 'Category'
};

exports.Prisma.ModelName = {
  Product: 'Product',
  ProductOption: 'ProductOption',
  ProductOptionValue: 'ProductOptionValue',
  ProductOptionOnProducts: 'ProductOptionOnProducts',
  ProductOptionValuesOnSkus: 'ProductOptionValuesOnSkus',
  Color: 'Color',
  Size: 'Size',
  SizeMatrix: 'SizeMatrix',
  Currency: 'Currency',
  ProductVariant: 'ProductVariant',
  ProductRange: 'ProductRange',
  Sku: 'Sku',
  Customer: 'Customer',
  Log: 'Log',
  Address: 'Address',
  Checkout: 'Checkout',
  CheckoutLineItem: 'CheckoutLineItem',
  Discount: 'Discount',
  Asset: 'Asset',
  Shipment: 'Shipment',
  ShipmentLineItems: 'ShipmentLineItems',
  AssetEntity: 'AssetEntity',
  ProductVariantGrid: 'ProductVariantGrid',
  ProductVariantGridOnProductVariants: 'ProductVariantGridOnProductVariants',
  Category: 'Category',
  CategoriesOnProducts: 'CategoriesOnProducts',
  ShippingZone: 'ShippingZone',
  ShippingService: 'ShippingService',
  ShippingZonesOnServices: 'ShippingZonesOnServices',
  AdminUser: 'AdminUser',
  StoreCurrencies: 'StoreCurrencies',
  Store: 'Store',
  ProductMaterials: 'ProductMaterials',
  Material: 'Material',
  MaterialOption: 'MaterialOption',
  MaterialOptionValue: 'MaterialOptionValue',
  MaterialPrice: 'MaterialPrice',
  Supplier: 'Supplier',
  PurchaseOrder: 'PurchaseOrder',
  Webhook: 'Webhook',
  WebhookLog: 'WebhookLog',
  Bundle: 'Bundle',
  BundlesOnProductVariants: 'BundlesOnProductVariants',
  InternalApiRequestLog: 'InternalApiRequestLog',
  ProductPrice: 'ProductPrice',
  StoreMarket: 'StoreMarket',
  Notification: 'Notification'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://github.com/prisma/prisma/issues`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
